:host {
  display: block;
  position: relative;
}

.item {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: var(--header-nav-item-gap);
  block-size: var(--header-nav-item-block-size);
  padding-inline: var(--header-nav-item-padding-inline-start);
  border: 0;
  background-color: transparent;
  cursor: pointer;
  font-family: var(--header-nav-item-font-family);
  font-size: var(--header-nav-item-font-size);
  line-height: var(--header-nav-item-line-height);
  font-weight: var(--header-nav-item-font-weight);
  color: var(--header-nav-item-color);
  white-space: nowrap;
  text-decoration: none;
}

/* Expandable items leave room for the trailing chevron. */
:host([expandable]) .item {
  padding-inline-end: var(--header-nav-item-padding-inline-end);
}

/* Status hint shown as a tooltip on hover/focus (no arrow). */
.tag-tooltip {
  position: absolute;
  bottom: calc(100% - 4px);
  inset-inline-start: 50%;
  transform: translateX(-50%);
  z-index: 30;
  padding-block: var(--spacing-2, 2px);
  padding-inline: var(--spacing-8, 8px);
  border-radius: var(--border-radius-4, 4px);
  background-color: var(--color-background-base-inverse-default, #1e1e1e);
  color: var(--color-background-base-inverse-on-color, #ffffff);
  font-family: var(--header-nav-item-font-family);
  font-size: var(--font-size-14, 14px);
  line-height: var(--line-height-20, 20px);
  font-weight: var(--font-weight-medium, 500);
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 120ms ease-out;
}

:host(:hover) .tag-tooltip,
:host(:focus-within) .tag-tooltip {
  opacity: 1;
  visibility: visible;
}

.chevron {
  flex: none;
  color: var(--header-nav-item-color);
  transition: transform 150ms ease-out;
}

:host([expanded]) .chevron {
  transform: rotate(180deg);
}

/* Hover + open. */
:host(:not([disabled])) .item:hover,
:host([active]) .item {
  background-color: var(--header-nav-item-hover-background);
}

/* Disabled (e.g. "coming soon"). */
:host([disabled]) .item {
  color: var(--header-nav-item-disabled-color);
  background-color: var(--header-nav-item-hover-background);
  cursor: default;
}

:host([disabled]) .chevron {
  color: var(--header-nav-item-disabled-color);
}

/* Keyboard focus. */
.item:focus-visible {
  outline: var(--header-container-border-width, 1px) solid var(--color-border-brand-default);
  outline-offset: -2px;
}
